import { createService } from '@bonanza-social/toolkit/api';
import { JackpotsSchema } from './JackpotsService.schemas';

export default createService({
  getJackpots: {
    method: 'GET',
    url: '/activeJackpots',
    responseSchema: JackpotsSchema,
  },
});
